<script lang="ts">
  import { onMount, type Snippet } from 'svelte';
  
  interface Props {
    children?: Snippet;
    onIntersectionBegin: () => void;
    onIntersectionEnd: () => void;
  }

  // intersection trigger
  // triggers given function when element is in viewport

  const { children, onIntersectionBegin, onIntersectionEnd }: Props = $props();
  let container: HTMLDivElement;

  onMount(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries.length === 0){
        return;
      }
      const entry = entries[0];
      if (entry.isIntersecting) {
        onIntersectionBegin();
      } else {
        onIntersectionEnd();
      }
    });
    observer.observe(container);
    return () => {
      observer.unobserve(container);
    };
  });
</script>

<div bind:this={container}>
  {#if children}
    {@render children()}
  {:else}
    <p class="text-center my-3 fst-italic">Loading...</p>
  {/if}
</div>
